import { Component, OnInit, Input } from '@angular/core';
import { Translation } from '@3ddv/ngx-sites-builder-lib';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { TranslationService } from '../translation.service';

@Component({
  selector: 'app-translation-file',
  templateUrl: './translation-file.component.html',
  styleUrls: ['./translation-file.component.scss']
})
export class TranslationFileComponent implements OnInit {
  
  @Input() tool: Translation;
  public postedFile;
  public downloadTemplate: SafeUrl;

  constructor(private toastrService: ToastrService,
              private sanitizer: DomSanitizer,
              private translationService: TranslationService) { }

  ngOnInit(): void {
    this.generateTemplate();
    
    var tempFile = this.translationService.getTempFile();
    if (tempFile) {
      this.postedFile = tempFile;
    };

    if (this.tool.fileData) {
      // Setear la fileData en la tool.data y luego sobreescribir con la customData si hay.
      this.tool.data = JSON.parse(JSON.stringify(this.tool.fileData));
      // Adds or overwrites customData to tool.data
      this.tool = this.translationService.addCustomData(this.tool);
    }
  }
  
  private generateTemplate(){
    let template = {
      "S_123" : "New name"
    };
    let data = JSON.stringify(template);
    this.downloadTemplate = this.sanitizer.bypassSecurityTrustUrl("data:text/json;charset=UTF-8," + encodeURIComponent(data));
  }
  
  private readFile(file){
    this.postedFile = file;
    this.translationService.saveTempFile(file);
    const fileReader = new FileReader();
    fileReader.readAsText(this.postedFile, "UTF-8");
    fileReader.onload = ()=>{
      // Setear la fileData en la tool.data y luego sobreescribir con la customData si hay.
      this.tool.fileData = JSON.parse(fileReader.result.toString());
      this.tool.data = JSON.parse(JSON.stringify(this.tool.fileData));
      // Adds or overwrites customData to tool.data
      this.tool = this.translationService.addCustomData(this.tool);
    }
  }
  
  public onFileSelected($event){
    if(!$event.target.files.length) return;
    if(($event.target.files[0].type == "" && $event.target.files[0].size == 0) || $event.target.files[0].type != "application/json"){
      this.toastrService.error("", "Formato del fichero inválido");
      return;
    }
    this.readFile($event.target.files[0]);
  }

  public onFileDropped($event){
    if(!$event.length) return;
    if(($event[0].type == "" && $event[0].size == 0) || $event[0].type != "application/json"){
      this.toastrService.error("", "Formato del fichero inválido");
      return;
    }
    this.readFile($event[0]);
  }
  
  public deleteDroppedFile(){
    this.postedFile = null;
    this.tool.file = null;
    this.tool.fileData = null;
    // Reset de la tool.data para borrar los datos que vinieran del file y volver a guardarle los que vengan de custom text para no perderlos.
    this.tool.data = null;
    // Adds or overwrites customData to tool.data
    this.tool = this.translationService.addCustomData(this.tool);
  }

}
